// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__QRj-L","backdropButton":"Modal_backdropButton__FPopu","panel":"Modal_panel__959wX"};